import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Confirm, Formatter, OptionDropdown, Spinner, PopOver, InfoTooltip,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

import {
  arretraTrasmessaManualmente, completa, creaSostitutivaDaEsistente, daInviare, elimina, riapri,
} from 'apis/successioniApi';
import { AccettatoIcon, AssenteIcon, RifiutatoIcon } from 'dashboard/Icons';
import TipoDichiarazione from 'enums/TipoDichiarazione';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import Servizi from 'enums/Servizi';
import ModaleAllegaRicevuta from './ModaleAllegaRicevuta';
import ModaleAllegaRicevutaSecondaria from './ModaleAllegaRicevutaSecondaria';
import ModaleCreaVoltura from './ModaleCreaVoltura';
import ModaleTrasmissioneManuale from './ModaleTrasmissioneManuale';
import ModaleStorico from '../Shared/ModaleStorico';
import { capitalizeFirstLetter } from '../../helpers/stringHelper';
import checkServizio from '../../helpers/checkServizio';

class RigaDichiarazione extends Component {
  constructor(props) {
    super(props);

    this.state = {
      storico: false,
      visualizzaTrasmissioneManuale: false,
      allegaRicevuta: false,
      allegaRicevutaSecondaria: false,
      attesa: false,
    };

    this.initializeComponent();
  }

  initializeComponent() {
    this.allegaRicevuta = this.allegaRicevuta.bind(this);
    this.allegaRicevutaSecondaria = this.allegaRicevutaSecondaria.bind(this);
    this.creaVoltura = this.creaVoltura.bind(this);
    this.vaiADichiarazione = this.vaiADichiarazione.bind(this);
    this.visualizzaDichiarazione = this.visualizzaDichiarazione.bind(this);
    this.stampa = this.stampa.bind(this);
    this.stampaprospettoautoliquidazione = this.stampaprospettoautoliquidazione.bind(this);
    this.stampaprospettoautoliquidazionevuoto = this.stampaprospettoautoliquidazionevuoto.bind(this);
    this.stampaF24 = this.stampaF24.bind(this);
    this.stampaF24vuoto = this.stampaF24vuoto.bind(this);
    this.scaricaEsitoPagamentoF24 = this.scaricaEsitoPagamentoF24.bind(this);
    this.scaricaPostControlli = this.scaricaPostControlli.bind(this);
    this.scaricaEsitoVoltura = this.scaricaEsitoVoltura.bind(this);
    this.telematico = this.telematico.bind(this);
    this.esito = this.esito.bind(this);
    this.elimina = this.elimina.bind(this);
    this.completacmd = this.completacmd.bind(this);
    this.riapri = this.riapri.bind(this);
    this.daInviare = this.daInviare.bind(this);
    this.invia = this.invia.bind(this);
    this.sostituivaNuova = this.sostituivaNuova.bind(this);
    this.sostituivaSenza = this.sostituivaSenza.bind(this);
    this.sostituivaAllegati = this.sostituivaAllegati.bind(this);
    this.trasmettiManualmente = this.trasmettiManualmente.bind(this);
    this.modificativaModello4 = this.modificativaModello4.bind(this);
    this.integrativaModello4 = this.integrativaModello4.bind(this);
    this.sostitutivaModello4 = this.sostitutivaModello4.bind(this);
    this.aggiuntivaModello4 = this.aggiuntivaModello4.bind(this);
  }

  vaiADichiarazione() {
    if (this.props.servizioAttivo == true && this.props.item.Stato == StatoDichiarazione.InLavorazione) {
      window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${this.props.item.IdDichiarazione.split('/')[1]}`;
    } else {
      window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/Visualizza/${this.props.item.IdDichiarazione.split('/')[1]}`;
    }
  }

  visualizzaDichiarazione() {
    window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/Visualizza/${this.props.item.IdDichiarazione.split('/')[1]}`;
  }

  stampa() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadStampa/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  stampaprospettoautoliquidazione() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadStampeVarie/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}&stampa=ProspettoAutoliquidazione`, '_blank');
  }

  stampaprospettoautoliquidazionevuoto() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadStampeVarie/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}&stampa=ProspettoAutoliquidazioneVuoto`, '_blank');
  }

  stampaF24() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadStampeVarie/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}&stampa=F24`, '_blank');
  }

  stampaF24vuoto() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadStampeVarie/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}&stampa=F24Vuoto`, '_blank');
  }

  scaricaEsitoPagamentoF24() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadEsitoPagamentoF24/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  scaricaEsitoVoltura() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadEsitoVoltura/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  scaricaPostControlli() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadEsitoPostControlli/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  telematico() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadTelematico/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  esito() {
    window.open(`${window.config.urlSuccessioni}/DichiarazioneSuccessione/DownloadEsito/?idDichiarazione=DichiarazioneSuccessione/${this.props.item.IdDichiarazione.split('/')[1]}&studio=${this.props.item.CodiceUfficio}&codiceFiscale=${this.props.item.CodiceFiscale}`, '_blank');
  }

  elimina() {
    Confirm('Elimina dichiarazione', 'Sei sicuro di voler eliminare questa dichiarazione?', 'error').then((x) => {
      elimina(this.props.item.IdDichiarazione).then((x) => {
        if (x.Success) {
          SnackbarManager.notifySuccess('Dichiarazione eliminata con successo');
        } else {
          SnackbarManager.notifyError(x.DetectedProblems);
        }
      });
    });
  }

  completacmd(dataContabilizzazione) {
    const handleCompletion = () => {
      completa(this.props.item.IdDichiarazione).then((x) => {
        if (x.Success) {
          SnackbarManager.notifySuccess('Dichiarazione completata');
        } else {
          SnackbarManager.notifyError(x.DetectedProblems);
        }
      });
    };

    if (dataContabilizzazione === undefined) {
      Confirm('Conferma completamento', <span>ATTENZIONE: impostando la dichiarazione con lo status Completa verr&agrave; contabilizzata ai fini della fatturazione. Eventuali rinvii della stessa dichiarazione non verranno conteggiati. Continuare ?</span>, 'success').then(handleCompletion);
    }
    else {
      //dichiarazione già contabilizzata, la porto avanti direttamente
      handleCompletion();
    }
  }

  riapri() {
    riapri(this.props.item.IdDichiarazione).then((x) => {
      if (x.Success) {
        SnackbarManager.notifySuccess('Dichiarazione riaperta');
      } else {
        SnackbarManager.notifyError(x.DetectedProblems);
      }
    });
  }

  daInviare(invioTelematicoAbilitato) {
    if (invioTelematicoAbilitato) {
      Confirm(
        'Conferma invio telematico',
        <span>
          &Egrave; attivo il servizio Invio Telematico. Vuoi continuare con l’invio in Agenzia delle Entrate?
        </span>,
        'success',
      )
        .then(() => this.invia());
    } else {
      this.invia();
    }
  }

  invia() {
    this.setState({ attesa: true });
    daInviare(this.props.item.IdDichiarazione)
      .then((x) => {
        this.setState({ attesa: false });
        if (x.Success) {
          SnackbarManager.notifySuccess('Dichiarazione avanzata a da inviare');
        } else {
          SnackbarManager.notifyError(x.DetectedProblems);
        }
      });
  }

  sostituivaNuova() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SostitutivaConNuovaTrascrizioneEVoltura, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  sostituivaSenza() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SostitutivaSenzaNuovaTrascrizioneEVoltura, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  sostituivaAllegati() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SostitutivaSoliAllegati, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  modificativaModello4() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SuccessioniCartaceaModificativa, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  integrativaModello4() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SuccessioniCartaceaIntegrativa, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  sostitutivaModello4() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SuccessioniCartaceaSostitutiva, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  aggiuntivaModello4() {
    creaSostitutivaDaEsistente(this.props.item.IdDichiarazione, TipoDichiarazione.SuccessioniCartaceaAggiuntiva, this.props.item.CodiceUfficio)
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      });
  }

  riapriTrasmessaManualmente() {
    arretraTrasmessaManualmente(this.props.item.IdDichiarazione).then((resp) => {
      if (resp.Success) {
        SnackbarManager.notifySuccess('Dichiarazione arretrata');
      } else {
        SnackbarManager.notifyError(resp.DetectedProblems);
      }
    });
  }

  creaVoltura() {
    this.setState({ creaVoltura: true });
  }

  trasmettiManualmente() {
    this.setState({ visualizzaTrasmissioneManuale: true });
  }

  allegaRicevuta() {
    this.setState({ allegaRicevuta: true });
  }

  allegaRicevutaSecondaria() {
    this.setState({ allegaRicevutaSecondaria: true });
  }

  descrizioneStatoDichiarazione(stato, haErrori) {
    switch (stato) {
      case StatoDichiarazione.DaTrasmettere:
        return 'Invio telematico in corso';
      case StatoDichiarazione.TrasmissioneNonRiuscita:
        return 'Invio telematico fallito';
      default:
        return StatoDichiarazione.stringify(stato, haErrori);
    }
  }

  render() {
    const { item, servizioAdeleAttivo } = this.props;

    const datiAggiuntivi = item.DatiAddizionali != null ? typeof item.DatiAddizionali === 'object' && item.DatiAddizionali !== null ? item.DatiAddizionali : JSON.parse(item.DatiAddizionali) : {};
    const modello4 = item.Tipo === TipoDichiarazione.SuccessioniCartaceaPrimaDichiarazione
      || item.Tipo === TipoDichiarazione.SuccessioniCartaceaModificativa
      || item.Tipo === TipoDichiarazione.SuccessioniCartaceaIntegrativa
      || item.Tipo === TipoDichiarazione.SuccessioniCartaceaSostitutiva
      || item.Tipo === TipoDichiarazione.SuccessioniCartaceaAggiuntiva;

    const tipoDichiarazioneOrigineCompatibileConIntegrativa1e2 = item.Tipo !== TipoDichiarazione.SostitutivaSoliAllegati;
    const avvisoTipoDichiarazioneOrigineCompatibileConIntegrativa1e2 = (<InfoTooltip>Questo tipo di sostitutiva non può essere creato dalla sostitutiva soli allegati</InfoTooltip>);

    // flag che l'uente può mettere nella dichiarazione per forzare l'invio manuale anche se attivo il serivizio di invio telematico
    const flagInvioManuale = !!datiAggiuntivi.InvioTelematicoManuale && datiAggiuntivi.InvioTelematicoManuale === 'True';
    // in funzione dell'ambiente
    const toggleInvioTelematico = window.config.toggleSuccessioniInvioTelematicoUfficiAbilitati === '*'
      || (!!window.config.toggleSuccessioniInvioTelematicoUfficiAbilitati && window.config.toggleSuccessioniInvioTelematicoUfficiAbilitati
        .split(',')
        .map((u) => u.trim())
        .includes(item.CodiceUfficio));
    const invioTramiteInvioTelematico = !modello4 && !flagInvioManuale && servizioAdeleAttivo && toggleInvioTelematico;

    return (
      <tr key={item.Id}>
        <td onClick={this.vaiADichiarazione}>{item.CodiceFiscale.toUpperCase()}</td>
        <td onClick={this.vaiADichiarazione}>{item.Cognome.toUpperCase()}</td>
        <td onClick={this.vaiADichiarazione}>{item.Nome.toUpperCase()}</td>
        <td onClick={this.vaiADichiarazione}>{this.descrizioneStatoDichiarazione(item.Stato, item.HaErrori)}</td>
        <td onClick={this.vaiADichiarazione}>{TipoDichiarazione.stringify(item.Tipo)}</td>
        <td onClick={this.vaiADichiarazione}>{datiAggiuntivi.TipoDevoluzione}</td>
        <td className="text--center">{datiAggiuntivi.FiscoOnline == 'True' && <SuccessoIcon />}</td>
        <td onClick={this.vaiADichiarazione}><Formatter valore={datiAggiuntivi.DataScadenza} tipo="date" /></td>
        <td className="text--center">{datiAggiuntivi.IdRicevutaEsitoPagamentoF24 == 'True' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito pagamento importata correttamente"><AccettatoIcon onClick={this.scaricaEsitoPagamentoF24} /></PopOver>}{(datiAggiuntivi.IdRicevutaEsitoPagamentoF24 == undefined || datiAggiuntivi.IdRicevutaEsitoPagamentoF24 == '') && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito pagamento non caricata"><AssenteIcon onClick={this.props.servizioAttivo == true && this.allegaRicevutaSecondaria} /></PopOver>}{datiAggiuntivi.IdRicevutaEsitoPagamentoF24 == 'False' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito pagamento scartata"><RifiutatoIcon onClick={this.vaiADichiarazione} /></PopOver>}</td>
        <td className="text--center">{datiAggiuntivi.IdRicevutaRicevutaPostControlli == 'True' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito Controlli Definitivi importata correttamente"><AccettatoIcon onClick={this.scaricaPostControlli} /></PopOver>}{(datiAggiuntivi.IdRicevutaRicevutaPostControlli == undefined || datiAggiuntivi.IdRicevutaRicevutaPostControlli == '') && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito definitivo non caricata"><AssenteIcon onClick={this.props.servizioAttivo == true && this.allegaRicevutaSecondaria} /></PopOver>}{datiAggiuntivi.IdRicevutaRicevutaPostControlli == 'False' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito Controlli Definitivi scartata"><RifiutatoIcon onClick={this.vaiADichiarazione} /></PopOver>}</td>
        <td className="text--center">{datiAggiuntivi.IdRicevutaEsitoVoltura == 'True' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito Voltura importata correttamente"><AccettatoIcon onClick={this.scaricaEsitoVoltura} /></PopOver>}{(datiAggiuntivi.IdRicevutaEsitoVoltura == undefined || datiAggiuntivi.IdRicevutaEsitoVoltura == '') && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito Voltura non caricata"><AssenteIcon onClick={this.props.servizioAttivo == true && this.allegaRicevutaSecondaria} /></PopOver>}{datiAggiuntivi.IdRicevutaEsitoVoltura == 'False' && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && <PopOver bottom content="Ricevuta esito Voltura scartata"><RifiutatoIcon onClick={this.vaiADichiarazione} /></PopOver>}</td>
        <td>
          {this.state.attesa
            ? <Spinner small />
            : (
              <OptionDropdown>
                {(item.Stato == StatoDichiarazione.InLavorazione && this.props.servizioAttivo == true)
                  ? <OptionDropdown.Item onClick={this.vaiADichiarazione}>Modifica</OptionDropdown.Item>
                  : <OptionDropdown.Item onClick={this.visualizzaDichiarazione}>Visualizza</OptionDropdown.Item>}

                <OptionDropdown.Item onClick={this.stampa}>Stampa</OptionDropdown.Item>

                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === true
                  && <OptionDropdown.Item onClick={this.modificativaModello4}>Crea Modificativa</OptionDropdown.Item>
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === true
                  && <OptionDropdown.Item onClick={this.integrativaModello4}>Crea Integrativa</OptionDropdown.Item>
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === true
                  && <OptionDropdown.Item onClick={this.sostitutivaModello4}>Crea Sostitutiva</OptionDropdown.Item>
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === true
                  && <OptionDropdown.Item onClick={this.aggiuntivaModello4}>Crea Aggiuntiva</OptionDropdown.Item>
                }

                {modello4 === true
                  && <OptionDropdown.Item onClick={this.stampaprospettoautoliquidazione}>Stampa prospetto autoliquidazione</OptionDropdown.Item>}
                {modello4 === true
                  && <OptionDropdown.Item onClick={this.stampaF24}>Stampa modello F24</OptionDropdown.Item>}
                {modello4 === true
                  && <OptionDropdown.Item onClick={this.stampaprospettoautoliquidazionevuoto}>Stampa prospetto autoliquidazione (vuoto)</OptionDropdown.Item>}
                {modello4 === true
                  && <OptionDropdown.Item onClick={this.stampaF24vuoto}>Stampa modello F24 (vuoto)</OptionDropdown.Item>}

                {this.props.servizioAttivo == true && item.Stato == StatoDichiarazione.InLavorazione && !item.HaErrori
                  && <OptionDropdown.Item onClick={() => this.completacmd(datiAggiuntivi.DataContabilizzazione)}>Completa</OptionDropdown.Item>}

                {this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.Completa
                  && <OptionDropdown.Item onClick={() => this.daInviare(invioTramiteInvioTelematico)}>Porta a da inviare</OptionDropdown.Item>}

                {this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.DaInviare
                  && modello4 === false
                  && <OptionDropdown.Item onClick={this.telematico}>Scarica telematico</OptionDropdown.Item>}
                {
                  item.Stato == StatoDichiarazione.DaInviare
                  && modello4 === false
                  && <OptionDropdown.Item onClick={this.esito}>Visualizza esito Entratel</OptionDropdown.Item>
                }

                {
                  this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.DaInviare && datiAggiuntivi.FiscoOnline == 'True'
                  && <OptionDropdown.Item onClick={this.trasmettiManualmente}>Avanza a trasmessa manualmente</OptionDropdown.Item>
                }
                {
                  this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.DaInviare && datiAggiuntivi.FiscoOnline != 'True'
                  && <OptionDropdown.Item onClick={this.allegaRicevuta}>Allega ricevuta</OptionDropdown.Item>
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && <OptionDropdown.Item onClick={this.allegaRicevutaSecondaria}>Allega ricevute esiti</OptionDropdown.Item>
                }

                {
                  this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.TrasmessaManualmente
                  && <OptionDropdown.Item onClick={() => this.riapriTrasmessaManualmente()}>Arretra</OptionDropdown.Item>
                }

                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.Completa
                    || item.Stato == StatoDichiarazione.DaInviare
                    || item.Stato === StatoDichiarazione.TrasmissioneNonRiuscita
                    || item.Stato === StatoDichiarazione.ScartataEnte)
                  && <OptionDropdown.Item onClick={this.riapri}>Riporta in Lavorazione</OptionDropdown.Item>
                }

                {
                  this.props.servizioAttivo == true
                  && item.Stato == StatoDichiarazione.InLavorazione
                  && (
                    <OptionDropdown.Item
                      onClick={this.elimina}
                      disabled={!!item.DataPrimoCompletamento}
                      showInfo={!!item.DataPrimoCompletamento}
                      infoContent='E&quot; possibile eliminare solo dichiarazioni che non sono state contabilizzate. Se hai necessità di eliminare questo dichiarativo invia un quesito telematico.'
                    >Elimina
                    </OptionDropdown.Item>
                  )
                }

                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === false
                  && (
                    <OptionDropdown.Item
                      onClick={this.sostituivaNuova}
                      disabled={!tipoDichiarazioneOrigineCompatibileConIntegrativa1e2}
                    >
                      Crea sostitutiva con nuova trascrizione {
                        !tipoDichiarazioneOrigineCompatibileConIntegrativa1e2 && avvisoTipoDichiarazioneOrigineCompatibileConIntegrativa1e2
                      }
                    </OptionDropdown.Item>
                  )
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === false
                  && (
                    <OptionDropdown.Item
                      onClick={this.sostituivaSenza}
                      disabled={!tipoDichiarazioneOrigineCompatibileConIntegrativa1e2}
                    >
                      Crea sostitutiva senza nuova trascrizione {
                        !tipoDichiarazioneOrigineCompatibileConIntegrativa1e2 && avvisoTipoDichiarazioneOrigineCompatibileConIntegrativa1e2
                      }
                    </OptionDropdown.Item>
                  )
                }
                {
                  this.props.servizioAttivo == true
                  && (item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente)
                  && modello4 === false
                  && <OptionDropdown.Item onClick={this.sostituivaAllegati}>Crea sostitutiva soli allegati</OptionDropdown.Item>
                }

                {
                  this.props.servizioAttivo == true
                  && ((item.Stato == StatoDichiarazione.TrasmessaAutomaticamente || item.Stato == StatoDichiarazione.TrasmessaManualmente) && datiAggiuntivi.SenzaVoltureCatastali == 'True')
                  && <OptionDropdown.Item onClick={this.creaVoltura}>Crea Voltura</OptionDropdown.Item>
                }

                <OptionDropdown.Item onClick={() => this.setState({ storico: true })}>Storico</OptionDropdown.Item>
              </OptionDropdown>
            )}

          {this.state.storico
            && <ModaleStorico idDichiarazione={item.Id} onClose={() => this.setState({ storico: false })} />}
          {this.state.visualizzaTrasmissioneManuale
            && <ModaleTrasmissioneManuale idDichiarazione={item.IdDichiarazione} modello4={modello4} onClose={() => this.setState({ visualizzaTrasmissioneManuale: false })} />}
          {this.state.allegaRicevuta
            && <ModaleAllegaRicevuta idDichiarazione={item.IdDichiarazione} codiceUfficio={item.CodiceUfficio} onClose={() => this.setState({ allegaRicevuta: false })} />}
          {this.state.allegaRicevutaSecondaria
            && <ModaleAllegaRicevutaSecondaria idDichiarazione={item.IdDichiarazione} codiceUfficio={item.CodiceUfficio} onClose={() => this.setState({ allegaRicevutaSecondaria: false })} />}
          {this.state.creaVoltura
            && <ModaleCreaVoltura idDichiarazione={item.IdDichiarazione} onClose={() => this.setState({ creaVoltura: false })} />}
        </td>
      </tr>
    );
  }
}

const mapStoreToProps = (store) => {
  const serviziUfficio = store.utente.ufficioSelezionato.Servizi;
  const servizioInvioTelematico = 'ADE'; // alias: Adele
  const servizioAdeleAttivo = !!serviziUfficio.find((x) => x.CodiceServizio === servizioInvioTelematico && x.StatoAttivazione === 3);
  return {
    servizioAdeleAttivo,
  };
};

RigaDichiarazione.propTypes = {
  item: PropTypes.object,
  servizioAdeleAttivo: PropTypes.bool,
};

export default checkServizio(Servizi.SUC)(connect(mapStoreToProps)(RigaDichiarazione));
